<template>
  <div class="shadow-color">
    <div class="title">阴影颜色</div>
    <div
      class="btn"
      :style="{backgroundColor: color}"
      @click.stop="clickColor"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      color: '#c7c7c7',
      checked: '',
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    }),
  },
  created () {
    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.dropShadow.color
      }
    }, function (val, oldVal) {
      this.color = val
    });

    this.$bus.on(`cloud.colorPickerInput`, (obj, data) => {
      if (data.from === 'subtitleShadowColor') {
        let color = obj.hex;
        this.$store.commit('subtitle/updateSubtitleUndo', {
          subtitle: {
            dropShadow: {
              color
            }
          }
        });
      }
    });
  },
  mounted () {
    let container = document.querySelector('#subtitle');
    container.addEventListener('click', (ev) => {
      if (ev.target.closest('.setting-popup')) {
        return;
      }
      this.$bus.emit("wordCloud.hidePopups");
    });
  },
  methods: {
    clickColor (ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('subtitlePopup', {
        name: 'color-cloud',
        // 使用了mixins popup.vue 下两字段就非必传
        posx: rect.right - 212,
        posy: rect.bottom + 10,
        type: 1,
        hasEyedropper: false,
        color: this.color,
        from: 'subtitleShadowColor',
        isHideFooter: true,
        // source: this,
        // whichPart,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.shadow-color {
  display: flex;
  align-items: center;
  justify-content: start;
}
.title {
  font-size: 12px;
  color: #737596;
  margin-right: 8px;
}
.btn {
  width: 36px;
  height: 24px;
  background: #c7c7c7;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/shadowColor.vue